import { PREDEFINED_DATE_RANGE } from '@/types/common';

export const preDefinedRanges = [
  { label: 'Today', value: PREDEFINED_DATE_RANGE.TODAY },
  { label: 'Yesterday', value: PREDEFINED_DATE_RANGE.YESTERDAY },
  { label: 'This Week', value: PREDEFINED_DATE_RANGE.THIS_WEEK },
  { label: 'This Month', value: PREDEFINED_DATE_RANGE.THIS_MONTH },
  { label: 'Last Month', value: PREDEFINED_DATE_RANGE.LAST_MONTH },
  { label: 'This Quarter', value: PREDEFINED_DATE_RANGE.THIS_QUARTER },
  { label: 'This Year', value: PREDEFINED_DATE_RANGE.THIS_YEAR },
  { label: 'Last Quarter', value: PREDEFINED_DATE_RANGE.LAST_QUARTER },
  { label: 'Last Year', value: PREDEFINED_DATE_RANGE.LAST_YEAR },
];
export const ListViewType = {
  LIST: 'list',
  GRID: 'grid',
} as const;
export type ListViewType = (typeof ListViewType)[keyof typeof ListViewType];

export const LG_DRAWER_WIDTH = 720;
export const LG_DRAWER_CHAT_WIDTH = 720;

/* Z-index values based on Chakra UI's default theme */
export const HIGHEST_Z_INDEX = 1301;

export const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
